import { Container } from './styled';
import PropTypes from 'prop-types';
import { StatisticsLayout } from 'views/components';
import isEmpty from 'lodash/isEmpty';
import moment from 'moment';
import { statisticsActions } from 'core/Statistics';
import { useTranslation } from 'react-i18next';
import {
    BarChart,
    Card,
    InfoList,
    LineChart
} from 'mol-ui';
import React, { useState } from 'react';
import {
    clearObject,
    getRangeArray
} from 'shared/utils';
import {
    useDispatch,
    useSelector
} from 'hooks';

const AbsencesByLicense = ({
    tabController
}) => {

    const dispatch = useDispatch();
    const { t } = useTranslation();
    const {
        absencesByLicense,
        absencesByLicenseMonthly,
        loading,
        updating
    } = useSelector('statistics');
    const [currentFilters, setCurrentFilters] = useState({});
    const [selectedReason, setSelectedReason] = useState(null);

    const lineStart = moment(currentFilters?.start_date).add(-1, 'years').set('month', 1);
    const lineEnd = moment(currentFilters?.end_date);

    const onFiltersChange = filters => {
        setCurrentFilters(filters);
        dispatch(statisticsActions.getStatisticsAbsencesByLicense(clearObject({
            ...filters,
            end: moment(filters?.end_date).format('YYYY-MM'),
            reason_key: selectedReason,
            start: moment(filters?.start_date).add(-1, 'years').set('month', 1).format('YYYY-MM')
        })));
    };

    const onLicenseReasonClick = ({ key }) => {
        const newSelectedReason = key === selectedReason ? null : key;
        setSelectedReason(newSelectedReason);
        dispatch(statisticsActions.getStatisticsAbsencesByLicenseMonthly(clearObject({
            ...currentFilters,
            end: lineEnd.format('YYYY-MM'),
            reason_key: newSelectedReason,
            start: lineStart.format('YYYY-MM')
        })));
    };

    const lineConfig = getRangeArray(
        lineStart.year(),
        lineEnd.year(),
        { reverse: true }
    ).map(year => ({
        dataKey: year,
        label: year.toString()
    }));

    return (
        <StatisticsLayout
            filterPatients={ ['area', 'cost_center', 'hr_head', 'patient', 'license_reason', 'position', 'workplace'] }
            loading={ loading }
            tabController={ tabController }
            onFiltersChange={ onFiltersChange }
        >
            <Container>
                <InfoList
                    items={ absencesByLicense }
                />
                <Card margin="10px 0px 0px 0px" overflowX="auto" padding="10px">
                    <BarChart
                        config={ [{ dataKey: 'days', label: t('Ausencias') }] }
                        data={ absencesByLicense.slice(1) }
                        disabled={ updating }
                        selected={ selectedReason }
                        xAxisVerticalHeight={ 100 }
                        onClick={ onLicenseReasonClick }
                    />
                </Card>
                {
                    !isEmpty(currentFilters) &&
                    <Card margin="10px 0px 0px 0px" overflowX="auto" padding="10px">
                        <LineChart
                            legend
                            config={ lineConfig }
                            data={ absencesByLicenseMonthly }
                            disabled={ updating }
                        />
                    </Card>
                }
            </Container>
        </StatisticsLayout>
    );

};

AbsencesByLicense.propTypes = {
    tabController: PropTypes.object
};

export default AbsencesByLicense;
